import { Group } from "lucide-react"
import * as React from "react"

import { Button } from "../button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from "../dropdown-menu"

export type RowDensity = "compact" | "normal" | "comfortable"

interface DataGridDensityToggleProps {
    density: RowDensity
    onDensityChange: (density: RowDensity) => void
}

export function DataGridDensityToggle({
    density,
    onDensityChange,
}: DataGridDensityToggleProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="h-8 flex gap-2"
                >
                    <Group className="h-4 w-4" />
                    Density
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[180px]">
                <DropdownMenuLabel>Row Density</DropdownMenuLabel>
                <DropdownMenuRadioGroup value={density} onValueChange={(value) => onDensityChange(value as RowDensity)}>
                    <DropdownMenuRadioItem value="compact">Compact</DropdownMenuRadioItem>
                    <DropdownMenuRadioItem value="normal">Normal</DropdownMenuRadioItem>
                    <DropdownMenuRadioItem value="comfortable">Comfortable</DropdownMenuRadioItem>
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
